module.exports = __webpack_public_path__ + "img/4.fcfc1b91.jpg";